import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import {
  OfferConditionTypeEnum,
  type SellerPromotionV1,
} from '@redteclab/api/clients/bully'

import { useGlobalConfigContext } from '../../../global-config'
import { productAccessorOfferHasFreeItemSellerPromotion } from '../../model/productAccessor/productAccessorOfferHasFreeItemSellerPromotion'

type ProductSellerPromotionFlagProps = {
  sellerPromotion: SellerPromotionV1
}

export const ProductSellerPromotionFlag: FC<
  ProductSellerPromotionFlagProps
> = ({ sellerPromotion }) => {
  const { superScripts } = useGlobalConfigContext()

  const legalFootnoteNumber = superScripts.sellerPromotions ? (
    <sup>{superScripts.sellerPromotions}</sup>
  ) : null

  if (productAccessorOfferHasFreeItemSellerPromotion(sellerPromotion)) {
    return (
      <FormattedMessage
        id="seller.promotion.product.badge.freeItems"
        values={{
          payableItemCount:
            sellerPromotion.conditionValue - sellerPromotion.discountValue,
          sup: legalFootnoteNumber,
          targetItemCount: sellerPromotion.conditionValue,
        }}
      />
    )
  }

  if (
    sellerPromotion.conditionType === OfferConditionTypeEnum.MinimumOrderValue
  ) {
    return (
      <FormattedMessage
        id="seller.promotion.product.badge.discount.mov"
        values={{
          sup: legalFootnoteNumber,
        }}
      />
    )
  }

  return (
    <FormattedMessage
      id="seller.promotion.product.badge.discount"
      values={{
        sup: legalFootnoteNumber,
      }}
    />
  )
}
